import { IPerson } from '../../assessment-management.models';

export enum CascadingFocusPanelIds {
  SelectEntity = 'SelectEntity',
  SelectPeople = 'SelectPeople',
}

export enum ErrorMessage {
  NoPersonSelected = 'Please select at least one person.',
}

export interface IPeopleStepLayoutProps {
  assessmentSlug: string;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  people: IPerson[] | undefined;
  setPeople: (people: IPerson[]) => void;
  setRoleSlug: (roleSlug: string | undefined) => void;
  onBack: () => void;
  onNext: () => void;
}

